import React from "react";

//This component displays a message to the user letting them know that they do not have any snapshots.

function NoSnapshotsMessage() {
  return (
    <div className="no-snapshots">
      You have no snapshots. Make sure you have selected a repository. If you
      still do not see your snapshots, contact info@hecoanalytics.com
    </div>
  );
}

export default NoSnapshotsMessage;
